module.exports = __webpack_public_path__ + "static/media/image16.4db340a5.png";